function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { ScreenWidthMinLarge, ScreenWidthMinXLarge, ScreenWidthMinXXLarge, Text, mergeStyleSets } from '@fluentui/react';
import Slider from 'react-slick';
import SpzaComponent from './spzaComponent';
import { urlPush } from 'routerHistory';
import { InternalLink } from './internalLink';
import { getNpsModule } from '@appsource/utils/nps';
import classNames from 'classnames';
import { TelemetryImage } from '@shared/components/telemetryImage';
const contentStyles = mergeStyleSets({
    ribbonHeaderImage: {
        verticalAlign: 'top',
        display: 'inline-block',
        marginLeft: '8px'
    }
});
function CrouselNextArrow(props) {
    const { onClick } = props;
    return /*#__PURE__*/ _jsx("button", {
        className: classNames({
            crouselArrow: true,
            crouselArrowRight: true,
            'icon-arrow-right-32': true
        }),
        onClick: onClick,
        "aria-label": "Next page"
    });
}
function CrouselPrevArrow(props) {
    const { onClick } = props;
    return /*#__PURE__*/ _jsx("button", {
        className: classNames({
            crouselArrow: true,
            crouselArrowLeft: true,
            'icon-arrow-left-32': true
        }),
        onClick: onClick,
        "aria-label": "Previous page"
    });
}
class Ribbon extends SpzaComponent {
    componentDidMount() {
        window.addEventListener('resize', this.hideAriaHiddenTiles);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.hideAriaHiddenTiles);
    }
    componentDidUpdate() {
        this.hideAriaHiddenTiles();
    }
    hideAriaHiddenTiles() {
        // Fix https://github.com/akiran/react-slick/issues/1535
        Array.from(document.querySelectorAll('.slick-slide')).forEach((slide)=>{
            var _slide_classList;
            if ((_slide_classList = slide.classList) === null || _slide_classList === void 0 ? void 0 : _slide_classList.contains('slick-active')) {
                slide.style.visibility = 'visible';
            } else {
                slide.style.visibility = 'hidden';
            }
        });
    }
    visibleAriaHiddenTiles() {
        Array.from(document.querySelectorAll('.slick-slide')).forEach((slide)=>{
            slide.style.visibility = 'visible';
        });
    }
    onRibbonButtonClick() {
        var _getNpsModule;
        if (this.props.onClick) {
            this.props.onClick();
        } else {
            urlPush(this.props.seeMoreUrl, true);
        }
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.increaseActionsCounter('seeAllActionsCount');
    }
    renderRibbonButton() {
        return this.props.seeMoreUrl && /*#__PURE__*/ _jsxs(InternalLink, {
            onClick: ()=>this.onRibbonButtonClick(),
            className: "ribbonHeaderButton",
            href: this.props.seeMoreUrl,
            accEnabled: true,
            "aria-label": `see all for ${this.props.title}`,
            children: [
                this.props.seeMoreText,
                this.props.isSeeMoreButton && /*#__PURE__*/ _jsx(Text, {
                    variant: "medium",
                    className: "c-glyph"
                })
            ]
        });
    }
    renderCarouselTiles() {
        const { children } = this.props;
        const childrenCount = React.Children.count(children);
        const settings = {
            speed: 500,
            slidesToShow: 4,
            // Critical for dealing with a bug in react-slick which caused to double elements when infinite is true and slidesToShow is less than children count - https://github.com/akiran/react-slick/issues/1171
            infinite: childrenCount > 4,
            slidesToScroll: 1,
            swipeToSlide: false,
            responsive: [
                {
                    breakpoint: ScreenWidthMinXXLarge,
                    settings: {
                        slidesToShow: 3,
                        infinite: childrenCount > 3
                    }
                },
                {
                    breakpoint: ScreenWidthMinXLarge,
                    settings: {
                        slidesToShow: 2,
                        infinite: childrenCount > 2
                    }
                },
                {
                    breakpoint: ScreenWidthMinLarge,
                    settings: {
                        slidesToShow: 1,
                        infinite: childrenCount > 1
                    }
                }
            ],
            nextArrow: /*#__PURE__*/ _jsx(CrouselNextArrow, {}),
            prevArrow: /*#__PURE__*/ _jsx(CrouselPrevArrow, {}),
            beforeChange: ()=>this.visibleAriaHiddenTiles(),
            afterChange: ()=>this.hideAriaHiddenTiles()
        };
        return /*#__PURE__*/ _jsx("div", {
            className: "ribbonSlider",
            children: /*#__PURE__*/ _jsx(Slider, _object_spread_props(_object_spread({}, settings), {
                children: this.props.children
            }))
        });
    }
    renderTiles() {
        return /*#__PURE__*/ _jsx("div", {
            className: "ribbonTiles",
            children: this.props.carousel ? this.renderCarouselTiles() : this.props.children
        });
    }
    renderHeader() {
        const { imgSource, title, subHeader } = this.props;
        return title ? /*#__PURE__*/ _jsxs("div", {
            className: "ribbonHeaderContainer",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "ribbonHeader",
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            variant: "large",
                            className: "ribbonHeaderText",
                            as: 'h2',
                            children: title
                        }),
                        this.renderRibbonButton(),
                        imgSource && /*#__PURE__*/ _jsx(TelemetryImage, {
                            className: contentStyles.ribbonHeaderImage,
                            src: imgSource
                        })
                    ]
                }),
                subHeader ? /*#__PURE__*/ _jsx("div", {
                    className: "ribbonSubHeader",
                    children: subHeader
                }) : null
            ]
        }) : null;
    }
    renderImpl() {
        return /*#__PURE__*/ _jsxs("div", {
            className: 'ribbon',
            "aria-label": `${this.props.title} swimlane`,
            role: "banner",
            children: [
                this.renderHeader(),
                this.renderTiles()
            ]
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
export { Ribbon as default };
Ribbon.contextTypes = {
    renderErrorModal: PropTypes.func
};
